import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import OrderDetailsTable from 'components/tables/OrderDetailsTable';
import { Card, Col, Dropdown, Form, Row } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import OrderDetailsSummaryCard from 'components/cards/OrderDetailsSummaryCard';
import {
  BillingDetails,
  OtherDetails,
  // OtherDetails,
  ShippingDetails
} from 'components/modules/e-commerce/OrderDeliveryDetails';
import {
  faChevronDown,
  faPrint,
  faUndo
} from '@fortawesome/free-solid-svg-icons';
import Section from 'components/base/Section';
import { useEffect } from 'react';
import { useState } from 'react';
import {
  getOrderById,
  updateFulfillmentStatus,
  updatePaymentStatus,
  type OrderDetails as OrderDetailsType
} from 'api/orders/_requests';
import { useSelector } from 'react-redux';
import { RootState } from 'redux-state/store';
import toast from 'react-hot-toast';

const OrderDetails = () => {
  const { orderId } = useParams();
  const { user } = useSelector((state: RootState) => state.auth);
  const [orderDetails, setOrderDetails] = useState<OrderDetailsType | null>(
    null
  );

  useEffect(() => {
    const fetchOrderDetails = async () => {
      if (!orderId) return;
      const res = await getOrderById(orderId);
      console.log('thisis order', res);
      setOrderDetails(res);
    };

    fetchOrderDetails();
  }, [orderId]);

  const handlePaymentStatus = async (status: string) => {
    if (!orderId) return;
    const res = await updatePaymentStatus(orderId, status);
    if (res) {
      toast.success('Payment status updated successfully');
      setOrderDetails(prev => {
        if (!prev) return null;
        return {
          ...prev,
          paymentStatus: status
        };
      });
    }
  };

  const handleFulfillmentStatus = async (status: string) => {
    if (!orderId) return;
    const res = await updateFulfillmentStatus(orderId, status);
    if (res) {
      toast.success('Fulfillment status updated successfully');
      setOrderDetails(prev => {
        if (!prev) return null;
        return {
          ...prev,
          fulfillmentStatus: status
        };
      });
    }
  };

  return (
    <div>
      <Section small className="pt-5">
        <div className="mb-9">
          <h2 className="mb-1">
            Order <span>#{orderDetails?.orderId}</span>
          </h2>
          <div className="d-flex flex-wrap flex-between-center mb-3 gap-2">
            <p className="text-body-secondary lh-sm mb-0">
              {/* Customer ID :{' '}
              <Link className="fw-bold" to="#!">
                {' '}
                2364847
              </Link> */}
            </p>
            <div className="d-flex">
              <Button
                variant="link"
                className="ps-0 pe-3 text-body text-decoration-none"
                startIcon={<FontAwesomeIcon icon={faPrint} className="me-2" />}
              >
                Print
              </Button>
              <Button
                variant="link"
                className="px-3 text-body text-decoration-none"
                startIcon={<FontAwesomeIcon icon={faUndo} className="me-2" />}
              >
                Refund
              </Button>
              <Dropdown>
                <Dropdown.Toggle
                  variant=""
                  className="ps-3 pe-0 dropdown-caret-none text-decoration-none"
                >
                  More action
                  <FontAwesomeIcon icon={faChevronDown} className="ms-2" />
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                  <Dropdown.Item href="#/action-2">
                    Another action
                  </Dropdown.Item>
                  <Dropdown.Item href="#/action-3">
                    Something else
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
          <Row className="g-5 gy-7">
            <Col xs={12} xl={8} xxl={9}>
              <div className="mb-6">
                <OrderDetailsTable
                  products={orderDetails?.products}
                  subtotal={orderDetails?.totalAmount || 0}
                />
              </div>
              <Row className="gx-4 gy-6 g-xl-7 justify-content-sm-center justify-content-xl-start">
                <Col xs={12} sm="auto">
                  <BillingDetails
                    billingAddress={
                      orderDetails?.billingAddress || {
                        street: '',
                        city: '',
                        state: '',
                        postalCode: '',
                        country: '',
                        phone: ''
                      }
                    }
                  />
                </Col>

                <Col xs={12} sm="auto">
                  <ShippingDetails
                    shippingAddress={
                      orderDetails?.shippingAddress || {
                        street: '',
                        city: '',
                        state: '',
                        postalCode: '',
                        country: '',
                        phone: ''
                      }
                    }
                  />
                </Col>

                <Col xs={12} sm="auto">
                  <OtherDetails
                    paymentStatus={orderDetails?.paymentStatus || ''}
                    fulfillmentStatus={orderDetails?.fulfillmentStatus || ''}
                    deliveryStatus={orderDetails?.deliveryStatus || ''}
                  />
                </Col>
              </Row>
            </Col>
            <Col xs={12} xl={4} xxl={3}>
              <OrderDetailsSummaryCard
                className="mb-4"
                totalAmount={orderDetails?.totalAmount || 0}
                discountAmount={orderDetails?.discountAmount || 0}
                taxAmount={orderDetails?.taxAmount || 0}
                shippingCost={orderDetails?.shippingCost || 0}
                finalAmount={orderDetails?.finalAmount || 0}
              />
              {user?.role === 'vendor' && (
                <Card>
                  <Card.Body>
                    <Card.Title as="h3" className="mb-4">
                      Order Status
                    </Card.Title>
                    <h6 className="mb-2">Payment status</h6>
                    <Form.Select
                      className="mb-4"
                      value={orderDetails?.paymentStatus}
                      onChange={e => handlePaymentStatus(e.target.value)}
                    >
                      <option value="processing">Processing</option>
                      <option value="cancelled">Cancelled</option>
                      <option value="pending">Pending</option>
                      <option value="paid">Paid</option>
                      <option value="refunded">Refunded</option>
                    </Form.Select>
                    <h6 className="mb-2">Fulfillment status</h6>
                    <Form.Select
                      value={orderDetails?.fulfillmentStatus}
                      onChange={e => handleFulfillmentStatus(e.target.value)}
                    >
                      <option value="unfulfilled">Unfulfilled</option>
                      <option value="fulfilled">Fulfilled</option>
                      <option value="Pending">Pending</option>
                    </Form.Select>
                  </Card.Body>
                </Card>
              )}
            </Col>
          </Row>
        </div>
      </Section>
    </div>
  );
};

export default OrderDetails;
